import { CompassIcon, SplitIcon, TrendingUpIcon, ZapIcon, FlagIcon } from 'lucide-react';

export const infoSources = [
  'Allenamenti di nuoto',
  'Allenamenti di ciclismo',
  'Programmi di corsa',
  "Consigli sull'alimentazione",
  'Indicazioni sul recupero',
  'Checklist per il giorno della gara',
];

export const selfQuestions = [
  'Mi sto allenando abbastanza?',
  'Sto facendo troppo?',
  'Cosa dovrei fare questa settimana?',
  'Come posso bilanciare nuoto, ciclismo e corsa?',
  "Quando dovrei aumentare l'intensità?",
  'Quando è meglio recuperare?',
  "Come gestisco l'alimentazione negli allenamenti lunghi?",
  'Come faccio a capire se sto davvero migliorando?',
  'Cosa succederà nella settimana della gara?',
];

export const painPoints: {
  icon: typeof CompassIcon;
  title: string;
  body: string[];
  list?: string[];
  resolve?: string;
}[] = [
  {
    icon: CompassIcon,
    title: 'Non sai da dove iniziare',
    body: [
      'Un triathlon di lunga distanza richiede mesi di preparazione.',
      "Senza una struttura chiara, è facile passare da un allenamento all'altro senza comprendere come ogni sessione si inserisca nel percorso complessivo.",
    ],
    resolve:
      'IL SISTEMA TRIATHLON FULL DISTANCE™ organizza il percorso in sei fasi progressive, aiutandoti a comprendere la funzione di ciascuna fase.',
  },
  {
    icon: SplitIcon,
    title: 'Le tre discipline sembrano scollegate',
    body: [
      "Nuoto. Ciclismo. Corsa. Tre discipline, un'unica gara.",
      'La preparazione deve aiutarti a considerarle come parti di un unico percorso, anziché affrontarle come attività completamente separate.',
    ],
  },
  {
    icon: TrendingUpIcon,
    title: 'Non sai se stai progredendo davvero',
    body: [
      'Allenarsi più duramente non significa automaticamente allenarsi meglio.',
      'Senza un metodo per registrare la costanza, osservare il carico di allenamento e monitorare i progressi, può essere difficile capire se stai seguendo la direzione desiderata.',
    ],
  },
  {
    icon: ZapIcon,
    title: "Non sai come organizzare l'alimentazione",
    body: [
      'Una gara di lunga distanza richiede particolare attenzione alla gestione delle energie.',
      "L'allenamento è soltanto una parte della preparazione. Alimentazione, idratazione e pianificazione dello sforzo diventano aspetti importanti da considerare.",
    ],
  },
  {
    icon: FlagIcon,
    title: 'Il giorno della gara ti preoccupa',
    body: ['Puoi trascorrere mesi ad allenarti e arrivare alla settimana della competizione con tante domande:'],
    list: [
      'Cosa devo preparare?',
      'Cosa devo portare con me?',
      'Come organizzo la mattina della gara?',
      'Come preparo le transizioni?',
      'Come distribuisco le energie nelle diverse discipline?',
    ],
    resolve: 'Una gara ben organizzata non comincia sulla linea di partenza. Comincia con la preparazione.',
  },
];
